import { render, staticRenderFns } from "./Accesso.vue?vue&type=template&id=91b7fa92&"
import script from "./Accesso.vue?vue&type=script&lang=js&"
export * from "./Accesso.vue?vue&type=script&lang=js&"
import style0 from "./Accesso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports